import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DiaryEvent} from "@feature/diary";
import {DiaryDetailTypes, EventStatus} from "@feature/diary";
import {DiaryEventStatusProvider} from "@diary/services/diary-event-status-provider";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'mojo-diary-event',
  templateUrl: './diary-event.component.html',
  styleUrls: ['./diary-event.component.scss']
})
export class DiaryEventComponent implements OnInit {
  @Input() event: DiaryEvent;
  @ViewChild('myIdentifier', { static: true }) myIdentifier: ElementRef;
  @Output() onDiaryEventClicked = new EventEmitter<DiaryEvent>();
  @Input() isUndated: boolean;

  constructor(private datePipe: DatePipe,
              private diaryEventStatusProvider: DiaryEventStatusProvider) {
  }

  ngOnInit() {
  }

  public shouldShowEventDate(event: DiaryEvent): boolean {
    return (event.DateCompleted == null && (
      !this.isUndated || (this.isUndated && event.NoticeServedDate != null)
    ));
  }

  public hasUndatedEventNotStarted(event: DiaryEvent): boolean {
    const status = this.diaryEventStatusProvider.getUndatedEventStatus(event);
    return status == EventStatus.NotStarted;
  }

  public hasUndatedEventEnded(event: DiaryEvent): boolean {
    const status = this.diaryEventStatusProvider.getUndatedEventStatus(event);
    return status == EventStatus.Ended;
  }

  public isUndatedEventCurrent(event: DiaryEvent): boolean {
    const status = this.diaryEventStatusProvider.getUndatedEventStatus(event);
    return status == EventStatus.Current;
  }

  getEventStatusText(event: DiaryEvent): string {
    const status = this.isUndated ? this.diaryEventStatusProvider.getUndatedEventStatus(event) : this.diaryEventStatusProvider.getDatedEventStatus(event);

    if(status == EventStatus.Completed){
      return `${EventStatus.Completed} on ${this.datePipe.transform(event.DateCompleted, 'dd MMM yyyy')}`;
    }
    else if(status == EventStatus.NoticeServed){
      return `Notice Served on ${this.datePipe.transform(event.NoticeServedDate, 'dd MMM yyyy')}`;
    }else{
      return status;
    }
  }

  getColor(event: DiaryEvent): string {
    // temporary example colours until we get the actual mapping from SIT
    switch (event.DetailType || event.FallbackText) {
      case DiaryDetailTypes.Option:
        return '5px solid rgb(37,137,249)';
      case DiaryDetailTypes.Review:
        return '5px solid rgb(124,204,3)';
      case DiaryDetailTypes.Expiry:
        return '5px solid rgb(221,0,119)';
      default:
        return '5px solid rgb(251,126,1)';
    }
  }

  getDetailTypeText(detailType: string, fallbackText: string, matchType: string = '') : string {
    if (detailType != undefined && detailType != null && detailType.trim().length > 0)
      return `${detailType}${matchType == 'Notice' ?  ' - Notice' : ''}`;
    else
      return `${fallbackText}`;
  }

  showMore(event: any) {
    this.onDiaryEventClicked.emit(this.event);
  }
}
